export default function Growth() {
  return (
    <section
      data-stage="1b"
      className="relative min-h-[calc(65vh_+_41vw)] sm:min-h-[calc(65vh_+_34.5vw)] md:min-h-[calc(65vh_+_250px)] lg:min-h-[calc(65vh_+_294px)] w-full flex items-start justify-center overflow-hidden pt-32 md:pt-40"
    >

      <div className="relative z-10 w-full max-w-5xl px-6 md:px-12 text-center">
        <h2
          data-reveal
          data-delay="1"
          className="font-syncopator text-[19vw] sm:text-[16vw] md:text-[8.5rem] lg:text-[10rem] leading-[1.08] md:leading-[0.92] text-black font-light tracking-tightest drop-shadow-[0_4px_24px_rgba(0,0,0,0.35)]"
        >
          Können wir etwas
          <br />
          zu Ihrem Wachstum
          <br />
          beitragen?
        </h2>
      </div>
    </section>
  );
}